import $ from "jquery";

/**
 * (メニュー) ログアウト 発火イベント
 */
export const submitLogoutForm = function () {
    $("#logout_form").submit();
};

// 削除ボタン押下時 Submit
$("#delete_btn").click(function () {
    $("#delete_form").submit();
});

/**
 * (祝日設定) イベント発火定義
 */
/* テーブルのセルをClick時 */
$("#user_holiday_table td").click(function (this) {
    const type = $(this).data("type");
    $(".btn-close").hide();
    switch (type) {
        case "store":
            openUserHolidayRegistrationModal(this);
            break;
        // 祝日登録
        case "destory":
            openUserHolidayDeregistrationModal(this);
            break;
    }
});
/* 祝日登録確認Modal [登録]ボタンClick発火時 */
$("#user_holiday_regist_submit_btn").click(function () {
    submitUserHolidayRegistration();
});

/* 祝日登録確認Modal [キャンセル]ボタンClick発火時 */
$("#user_holiday_regist_cancel_btn").click(function () {
    cancelUserHolidayRegistration();
});

/* 祝日登録解除確認Modal [登録]ボタンClick発火時 */
$("#user_holiday_deregistration_submit_btn").click(function () {
    submitUserHolidayDeregistration();
});

/* 祝日登録解除確認Modal [キャンセル]ボタンClick発火時 */
$("#user_holiday_deregistration_cancel_btn").click(function () {
    cancelUserHolidayDeregistration();
});

/**
 * (祝日設定) 祝日登録確認Modal 表示
 */
const openUserHolidayRegistrationModal = function (element: Element) {
    // Modalに日付情報を渡す
    $("#user_holiday_create_date").text($(element).data("mdw"));

    // Formに日付情報を格納する
    $("#holiday").val($(element).data("date"));

};

/**
 * (祝日設定) 祝日登録確認Modal [登録]ボタン押下Sumit
 */
const submitUserHolidayRegistration = function () {
    $("#create_form").submit();
};

/**
 * (祝日設定) 祝日登録確認Modal [キャンセル]ボタン押下
 */
const cancelUserHolidayRegistration = function () {
    /* 格納値キャンセル */
    $("#user_holiday_create_date").text("");
    $("#holiday").val("");
};

/**
 * (祝日設定) 祝日登録解除確認Modal 表示
 */
const openUserHolidayDeregistrationModal = function (element: Element) {
    // Modalに日付情報を渡す
    $("#user_holiday_delete_date").text($(element).data("mdw"));

    // FormにActionを定義
    $("#delete_form").attr("action", $(element).data("route"));

};

/**
 * (祝日設定) 祝日登録解除確認Modal [解除]ボタン押下Sumit
 */
const submitUserHolidayDeregistration = function () {
    $("#delete_form").submit();
};

/**
 * (祝日設定) 祝日登録解除確認Modal [キャンセル]ボタン押下
 */
const cancelUserHolidayDeregistration = function () {
    /* 格納値キャンセル */
    $("#user_holiday_delete_date").text("");
    $("#delete_form").attr("action", "");
};

/**
 * (代理祝日設定) イベント発火定義
 */
/* テーブルのセルをClick時 */
$("#proxy_user_holiday_table td").click(function (this) {
    const type = $(this).data("type");
    $(".btn-close").hide();
    switch (type) {
        case "store":
            openProxyUserHolidayRegistrationModal(this);
            break;
        // 祝日登録
        case "destory":
            openProxyUserHolidayDeregistrationModal(this);
            break;
    }
});
/* 祝日登録確認(代理)Modal [登録]ボタンClick発火時 */
$("#proxy_user_holiday_regist_submit_btn").click(function () {
    submitProxyUserHolidayRegistration();
});

/* 祝日登録確認(代理)Modal [キャンセル]ボタンClick発火時 */
$("#proxy_user_holiday_regist_cancel_btn").click(function () {
    cancelProxyUserHolidayRegistration();
});

/* 祝日登録解除(代理)確認Modal [登録]ボタンClick発火時 */
$("#proxy_user_holiday_deregistration_submit_btn").click(function () {
    submitProxyUserHolidayDeregistration();
});

/* 祝日登録解除(代理)確認Modal [キャンセル]ボタンClick発火時 */
$("#proxy_user_holiday_deregistration_cancel_btn").click(function () {
    cancelProxyUserHolidayDeregistration();
});

/**
 * (祝日代理設定) 祝日登録確認Modal 表示
 */
const openProxyUserHolidayRegistrationModal = function (element: Element) {
    // Modalに日付情報を渡す
    $("#proxy_user_holiday_create_date").text($(element).data("mdw"));

    // Formに日付情報を格納する
    $("#holiday").val($(element).data("date"));

};

/**
 * (祝日代理設定) 祝日登録確認Modal [登録]ボタン押下Sumit
 */
const submitProxyUserHolidayRegistration = function () {
    $("#edit_form").submit();
};

/**
 * (祝日代理設定) 祝日登録確認Modal [キャンセル]ボタン押下
 */
const cancelProxyUserHolidayRegistration = function () {
    /* 格納値キャンセル */
    $("#proxy_user_holiday_create_date").text("");
    $("#holiday").val("");
};

/**
 * (祝日代理設定) 祝日登録解除確認Modal 表示
 */
const openProxyUserHolidayDeregistrationModal = function (element: Element) {
    // Modalに日付情報を渡す
    $("#proxy_user_holiday_delete_date").text($(element).data("mdw"));

    // FormにActionを定義
    $("#delete_form").attr("action", $(element).data("route"));

};

/**
 * (祝日代理設定) 祝日登録解除確認Modal [解除]ボタン押下Sumit
 */
const submitProxyUserHolidayDeregistration = function () {
    $("#delete_form").submit();
};

/**
 * (祝日代理設定) 祝日登録解除確認Modal [キャンセル]ボタン押下
 */
const cancelProxyUserHolidayDeregistration = function () {
    /* 格納値キャンセル */
    $("#proxy_user_holiday_delete_date").text("");
    $("#delete_form").attr("action", "");
};

/**
 * グローバル関数を定義
 */
// ログアウト 発火イベント
(window as any).submitLogoutForm = submitLogoutForm;
